import React, { FC } from 'react'
import { ResourceListsContainer } from './styles'

//* utils
import { backgroundThemes, paddingSizes } from '../../../constants/contentfulStyle.constant'
import { LanguageSelect, LocaleCodesSlugPrefix } from '../../../constants/localization.constants'
import { ComponentResourceLists } from '../../../models/components/resourceLists'
import { setBackgroundTheme, setPaddingSize } from '../../../utils/contentfulStyles.utils'

//* components
import GlobalContainer from '../globalContainer'
import Typography from '../typography'
import { ResourceButton, ResourceCategories } from './subcomponents'

type Props = {
  data: ComponentResourceLists
}

const ResourceLists: FC<Props> = ({ data }: any) => {
  if (!data) return null

  const langPrefix = LocaleCodesSlugPrefix[data.node_locale]
  const currLang =
    LanguageSelect.rows.find((language: any) => {
      return langPrefix === language.lang
    }) || LanguageSelect.rows[0]
  const uiPathUrl = currLang.href + '/'

  const topPaddingSize = setPaddingSize(data.topPadding, paddingSizes.LARGE.size)
  const bottomPaddingSize = setPaddingSize(data.bottomPadding, paddingSizes.LARGE.size)
  const isDarkTheme = data.theme === backgroundThemes.DARK

  return (
    <ResourceListsContainer
      data-cy="ResourceLists"
      $isDarkTheme={isDarkTheme}
      $topPaddingSize={topPaddingSize}
      $bottomPaddingSize={bottomPaddingSize}
      $backgroundColor={setBackgroundTheme(data.theme)}>
      <GlobalContainer className="ResourceLists__Grid">
        {data.title && (
          <Typography type="header3" className="text ResourceLists__Title">
            {data.title}
          </Typography>
        )}

        <ResourceButton
          ctaLabelOverride={data.ctaLabelOverride}
          ctaList={data.ctaList}
          theme={data.theme}
          uiPathUrl={uiPathUrl}
        />

        <ResourceCategories data={data} isDarkTheme={isDarkTheme} uiPathUrl={uiPathUrl} />
      </GlobalContainer>
    </ResourceListsContainer>
  )
}

export default ResourceLists
